// Shared types for LangGraph POST /chat responses (MexaScreen production chat).
export const STEP_LABELS = {
    project_scoping: 'Project Scoping',
    target_biology: 'Target Biology',
    pdb_selection: 'PDB Selection',
    receptor_preparation: 'Receptor Preparation',
    binding_site: 'Binding Site',
    screening: 'Screening',
    peptide_design: 'Peptide Design',
    docking: 'Docking',
};
export const STEP_COLORS = {
    project_scoping: '#0D00FF',
    target_biology: '#1c9b6d',
    pdb_selection: '#f59e0b',
    receptor_preparation: '#d97706',
    binding_site: '#ef4444',
    screening: '#0ea5e9',
    peptide_design: '#8b5cf6',
    docking: '#6366f1',
};
